import NavBar from "../Components/Common/navBar";
import Footer from "../Components/Common/footer";

import "./styles/contactUs.css";

const ContactUs = () => {
    return ( 
        <div className="contactUsPage">
            <NavBar />
            
            <div className="contactUsConent">
                <div className="contactUsImage_1">
                    <img src="/GiftWrapEnsembles-1.jpg" alt="contact-us-image" />
                </div>

                <div className="contactUsParagraph">
                    <h2>Have A Project In Mind? Let’s Talk.</h2>
                    <p>If you are looking for a special manufacturing request, please contact us at <a href="mailto:peter@glitterpaperdesigns.com">peter@glitterpaperdesigns.com</a></p>
                    <div className="contactUsParagraphLayout">
                        <div className="contactUsParagraphItem">
                            <h2>Careers</h2>
                            <p>We are excited to have you join our team. Contact us at <a href="mailto:careers@glitterpaperdesigns.com">careers@glitterpaperdesigns.com</a></p>
                        </div>
                        <div className="contactUsParagraphItem">
                            <h2>Mailing Address</h2>
                            <p>125 Clairmont Avenue, Suite 460,<br />Decatur, Georgia, 30030, USA</p>
                        </div>
                        <div className="contactUsParagraphItem">
                            <h2>Sales</h2>
                            <p>Are you interested in partnering with us? <a href="mailto:peter@glitterpaperdesigns.com">peter@glitterpaperdesigns.com</a></p>
                        </div>
                </div>
            </div>
                

            
                <Footer />
            </div>
        </div>
    )
}

export default ContactUs;